import { Theme, Tooltip, useTheme } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { FaCheck } from 'react-icons/fa';
import { SeverityType } from 'common-types';
import { resolveCategoryScore } from '../../applications/utils/application-utils';

const LinearStat: React.FC<React.PropsWithChildren<LinearStatProps>> = ({
  total,
  tooltip,
  severityScore,
  width = 40,
  height = 10,
}) => {
  const theme = useTheme();
  const { classes } = useStyles();
  const severityScorePercentage = resolveCategoryScore(severityScore);

  return (
    <div className={classes.linearStat}>
      <Tooltip
        enterDelay={500}
        enterNextDelay={500}
        title={tooltip || ''}
        placement='top'
        arrow>
        <div>
          {total > 0 ? (
            <div
              className={classes.progress}
              style={{ width, height, borderRadius: height }}>
              <div
                className={classes.bar}
                style={{
                  width: `${severityScorePercentage}%`,
                  backgroundColor: severityScore
                    ? theme.palette.categoryRiskColor[
                        severityScore.toLowerCase()
                      ]
                    : theme.palette.categoryRiskColor.info,
                }}
              />
            </div>
          ) : (
            <FaCheck className={classes.checkedIcon} />
          )}
        </div>
      </Tooltip>
    </div>
  );
};

const useStyles = makeStyles()((theme: Theme) => ({
  linearStat: {
    display: 'inline-flex',
    verticalAlign: 'middle',
    alignItems: 'center',
  },
  progress: {
    border: `2px solid ${theme.palette.divider}`,
  },
  bar: {
    transition: 'none !important',
    borderRadius: 'inherit',
    height: '100%',
  },
  checkedIcon: {
    width: 15,
    height: 15,
    color: '#99E280',
  },
}));

export interface LinearStatProps {
  total: number;
  tooltip?: JSX.Element | string;
  width?: number;
  height?: number;
  severityScore: SeverityType;
}

export default LinearStat;
